export { default as RichTextArea } from './rich-text-area';
export { FormRichTextArea } from './rich-text-area';
